import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { FiArrowRight, FiZap, FiCpu, FiTrendingUp, FiBarChart2, FiUpload } from "react-icons/fi";
import { useState, useEffect } from "react";

export default function Menu() {
    const navigate = useNavigate();

    // ✅ Stats animées par vidéo
    const statsData = [
    { score: "9.0 / 10", improvement: "+61%", views: "+42.1%" },
    { score: "7.4 / 10", improvement: "+33%", views: "+19.6%" },
    { score: "8.2 / 10", improvement: "+48%", views: "+31.8%" },
    { score: "6.9 / 10", improvement: "+22%", views: "+14.3%" },
    ];

    const [index, setIndex] = useState(0);

    useEffect(() => {
    const timing = setInterval(() => {
        setIndex((prev) => (prev + 1) % statsData.length);
    }, 3000);
    return () => clearInterval(timing);
    }, []);

    const currentStat = statsData[index];

    return (
        <div className="min-h-screen bg-[#0D1117] text-[#E6EDF3] pt-16 pb-28 px-6 sm:px-10 xl:px-20">

        {/* HERO */}
        <section className="flex flex-col lg:flex-row items-center justify-center text-center lg:text-left px-6 pb-28 max-w-6xl mx-auto gap-16">

        {/* LEFT */}
        <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="flex-1"
        >
        <h1 className="text-5xl sm:text-6xl font-extrabold leading-tight mb-6">
        Master your TikTok Hooks with{" "}
        <span className="bg-gradient-to-r from-[#3B82F6] to-[#06B6D4] text-transparent bg-clip-text">
            BoostMyHook
        </span>
        </h1>

        <p className="text-lg text-[#8B949E] mb-8 max-w-lg mx-auto lg:mx-0">
        Stop guessing and start winning. BoostMyHook analyzes the first seconds
        of your video and gives you an instant{" "}
        <span className="text-[#3B82F6] font-semibold">Hook Score</span> +
        personalized tips to increase retention.
        </p>

        <div className="flex justify-center lg:justify-start">
            <button
            onClick={() => navigate("/login")}
            className="flex items-center justify-center gap-2 bg-gradient-to-r from-[#3B82F6] to-[#06B6D4] text-white px-6 py-3 rounded-full text-lg font-medium hover:opacity-90 transition-all duration-200 shadow-[0_0_25px_#3B82F6]/40"
            >
            🎬 Test My Hook <FiArrowRight size={20} />
            </button>
        </div>

        {/* Badges */}
        <div className="flex flex-wrap justify-center lg:justify-start gap-6 mt-10 text-[#8B949E] text-sm">
            <div className="flex items-center gap-2">
            <FiZap className="text-[#3B82F6]" /> 1-click AI analysis
            </div>
            <div className="flex items-center gap-2">
            <FiCpu className="text-[#3B82F6]" /> Powered by OpenAI
            </div>
            <div className="flex items-center gap-2">
            <FiTrendingUp className="text-[#3B82F6]" /> For creators
            </div>
        </div>
        </motion.div>


        {/* ✅ RIGHT VISUAL — New Phone Mockup */}
        <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.15, duration: 0.5 }}
        className="flex-1 relative flex justify-center"
        >
        <div className="relative w-[320px] sm:w-[360px] h-[640px] bg-[#11161c] rounded-[2.25rem] border border-[#21262D] shadow-[0_10px_60px_rgba(59,130,246,0.25)] overflow-hidden">

            {/* Notch */}
            <div className="absolute top-3 left-1/2 -translate-x-1/2 w-36 h-6 bg-[#0D1117] rounded-b-2xl border border-[#1e232a]" />

            {/* ✅ Video */}
            <video
            src="/hookvideo.mp4"
            autoPlay
            loop
            muted
            playsInline
            className="absolute inset-0 w-full h-full object-cover pt-10 pb-6"
            />
        </div>

        {/* ✅ Animated Stats */}
        <div className="absolute -left-3 -bottom-5 bg-[#0D1117]/90 backdrop-blur-xl border border-[#2a3340]
            rounded-2xl px-4 py-3 shadow-[0_0_20px_rgba(59,130,246,0.5)]
            transition-all duration-300">
            <p className="text-xs text-[#9BA6B3]">Hook Score</p>
            <p className="text-2xl font-bold text-[#3B82F6]">
            {currentStat.score}
            </p>
            <div className="text-emerald-400 text-xs flex items-center gap-1">
            <FiTrendingUp /> {currentStat.improvement} retention
            </div>
        </div>

        <div className="absolute -right-3 top-5 bg-[#0D1117]/90 backdrop-blur-xl border border-[#2a3340]
            rounded-2xl px-4 py-3 shadow-[0_0_20px_rgba(168,85,247,0.5)]
            transition-all duration-300">
            <p className="text-xs text-[#9BA6B3]">Creators Helped</p>
            <p className="text-2xl font-bold text-[#A855F7]">
            18k+
            </p>
        </div>

        <div className="hidden sm:block absolute -left-6 top-16 bg-[#0D1117]/90 backdrop-blur-xl border border-[#2a3340]
            rounded-2xl px-4 py-3 shadow-[0_0_20px_rgba(6,182,212,0.5)]
            transition-all duration-300">
            <p className="text-xs text-[#9BA6B3]">Views gained</p>
            <p className="text-2xl font-bold text-[#06B6D4]">
            {currentStat.views}
            </p>
        </div>
        </motion.div>

        </section>

        {/* ✅ HOW IT WORKS — Refactored (no map) */}
<section className="py-32 px-6 bg-[#0D1117] border-t border-[#21262D] relative">

<div className="max-w-5xl mx-auto text-center mb-20">
  <h2 className="text-3xl sm:text-4xl font-bold text-[#E6EDF3] mb-4">
    How it works
  </h2>
  <p className="text-[#8B949E] text-lg max-w-2xl mx-auto">
    From upload to optimized hooks — AI enhances what keeps viewers watching.
  </p>
</div>

{/* ✅ Steps Container */}
<div className="relative max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-14 text-center">

  {/* ✅ CONNECTING PATH */}
  <div className="hidden sm:block absolute top-[50%] left-0 right-0 h-[2px] bg-[#2a3340] -z-10" />
  <div className="sm:hidden absolute left-[50%] top-0 bottom-0 w-[2px] bg-[#2a3340] -z-10" />

  {/* ✅ STEP 1 */}
  <motion.div
    initial={{ opacity: 0, y: 8 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.4 }}
    viewport={{ once: true }}
    className="relative bg-[#0D1117] border border-[#21262D]
    rounded-2xl px-8 py-6 flex flex-col items-center text-center
    drop-shadow-[0_0_25px_rgba(59,130,246,0.35)]
    max-w-xs sm:max-w-sm mx-auto"
  >
    <p className="text-xs text-[#9BA6B3] tracking-wide mb-3">STEP 1</p>
    <div className="text-[#3B82F6] mb-3"><FiUpload size={26} /></div>
    <h3 className="text-lg font-semibold text-[#E6EDF3] mb-2">Upload your video</h3>
    <p className="text-sm text-[#8B949E] leading-relaxed">
      MP4 or MOV — we analyze only the first seconds, the most important part.
    </p>
  </motion.div>

  {/* ✅ STEP 2 */}
  <motion.div
    initial={{ opacity: 0, y: 8 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.4, delay: 0.1 }}
    viewport={{ once: true }}
    className="relative bg-[#0D1117] border border-[#21262D]
    rounded-2xl px-8 py-6 flex flex-col items-center text-center
    drop-shadow-[0_0_25px_rgba(59,130,246,0.35)]
    max-w-xs sm:max-w-sm mx-auto"
  >
    <p className="text-xs text-[#9BA6B3] tracking-wide mb-3">STEP 2</p>
    <div className="text-[#3B82F6] mb-3"><FiCpu size={26} /></div>
    <h3 className="text-lg font-semibold text-[#E6EDF3] mb-2">
      AI analyzes your hook
    </h3>
    <p className="text-sm text-[#8B949E] leading-relaxed">
      Curiosity, clarity, pacing & voice evaluated with precision.
    </p>
  </motion.div>

  {/* ✅ STEP 3 */}
  <motion.div
    initial={{ opacity: 0, y: 8 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.4, delay: 0.2 }}
    viewport={{ once: true }}
    className="relative bg-[#0D1117] border border-[#21262D]
    rounded-2xl px-8 py-6 flex flex-col items-center text-center
    drop-shadow-[0_0_25px_rgba(59,130,246,0.35)]
    max-w-xs sm:max-w-sm mx-auto"
  >
    <p className="text-xs text-[#9BA6B3] tracking-wide mb-3">STEP 3</p>
    <div className="text-[#3B82F6] mb-3"><FiBarChart2 size={26} /></div>
    <h3 className="text-lg font-semibold text-[#E6EDF3] mb-2">
      Get your Hook Score
    </h3>
    <p className="text-sm text-[#8B949E] leading-relaxed">
      Video + Text scoring with actionable, AI-powered improvements.
    </p>
  </motion.div>

</div>
</section>


        {/* ✅ CTA */}
        <div className="text-center mt-24">
        <h3 className="text-2xl font-semibold mb-3">Ready to go viral?</h3>
        <p className="text-[#8B949E] mb-6">Upload your next video and see what’s holding back retention</p>

        <button
            onClick={() => navigate("/dashboard/hook")}
            className="px-8 py-3 rounded-full bg-gradient-to-r from-[#3B82F6] to-[#06B6D4] font-semibold hover:opacity-90 transition shadow-md"
        >
            🚀 Try BoostMyHook Now
        </button>
        </div>
    </div>
    );
}
